import BorrowCard from "./BorrowCard";

const BorrowList = ({ books, likedBooks, handleLikeClick, openBorrowModal, translations, getAvailabilityStyle }) => (
  <div className="flex flex-wrap mb-4">
    {books.map((book) => {
      const availabilityStyle = getAvailabilityStyle(book.bookAvailability);
      return (
        <BorrowCard
          key={book.id}
          book={book}
          liked={likedBooks[book.id]}
          onLikeClick={() => handleLikeClick(book.id)}
          onBorrowClick={openBorrowModal}  // تمرير الوظيفة
          availabilityStyle={availabilityStyle}
          translations={translations}
        />
      );
    })}
  </div>
);

export default BorrowList;
